import React, { useEffect, useState } from 'react';
import SzakokFinder from '../apis/SzakokFinder';

function MissingReportsTable() {
    const [szakfelelosok, setSzakfelelosok] = useState([]);
    const [szakNev, setSzakNev] = useState('');
    const [szakfelelosNev, setSzakfelelosNev] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'kepzes_neve', direction: 'asc' });
    const [message, setMessage] = useState('Betöltés...');

    useEffect(() => {
        let mounted = true;

        const fetchMissingReports = async () => {
            try {
                await SzakokFinder.get('/api/periods/active');
                const response = await SzakokFinder.get('/szakfelelosok');
                if (mounted) {
                    setSzakfelelosok((response.data?.data?.szakfelelosok || [])
                        .filter(szak => !szak.szakjelentes_created_this_period));
                    setMessage('');
                }
            } catch (err) {
                if (mounted) {
                    setMessage(err.response?.status === 404
                        ? 'Nincs aktív periódus beállítva.'
                        : 'Nem sikerült betölteni a szakok listáját.');
                }
            }
        };

        fetchMissingReports();
        return () => { mounted = false; };
    }, []);

    const handleSort = (key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    const renderSortIcon = (key) => {
        if (sortConfig.key !== key) return <span className="sort-icon default">⇅</span>;
        return <span className="sort-icon active">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
    };

    const sortedSzakfelelosok = szakfelelosok
        .filter(szak =>
            (szak.kepzes_neve || '').toLowerCase().includes(szakNev.toLowerCase()) &&
            (szak.szakfelelos_neve || '').toLowerCase().includes(szakfelelosNev.toLowerCase())
        )
        .sort((a, b) => {
            const comparison = (a[sortConfig.key] || '').localeCompare(b[sortConfig.key] || '', 'hu', { sensitivity: 'base' });
            return sortConfig.direction === 'asc' ? comparison : -comparison;
        });

    return (
        <>
            <div className="filters">
                <div className="filter">
                    <label htmlFor="missing-szak-nev">Szak név:</label>
                    <input
                        id="missing-szak-nev"
                        type="text"
                        value={szakNev}
                        onChange={e => setSzakNev(e.target.value)}
                        placeholder="Keresés szaknév alapján"
                    />
                </div>
                <div className="filter">
                    <label htmlFor="missing-szakfelelos-nev">Szakfelelős neve:</label>
                    <input
                        id="missing-szakfelelos-nev"
                        type="text"
                        value={szakfelelosNev}
                        onChange={e => setSzakfelelosNev(e.target.value)}
                        placeholder="Keresés szakfelelős neve alapján"
                    />
                </div>
            </div>

            {message ? <p className="missing-reports-message">{message}</p> : (
                <div className="table-container">
                    <table className="missing-reports-table">
                        <thead>
                            <tr>
                                <th className="sortable-th" onClick={() => handleSort('kepzes_neve')}>
                                    <div className="th-content">Szak neve {renderSortIcon('kepzes_neve')}</div>
                                </th>
                                <th className="sortable-th" onClick={() => handleSort('kepzesi_szint')}>
                                    <div className="th-content">Képzési szint {renderSortIcon('kepzesi_szint')}</div>
                                </th>
                                <th className="sortable-th" onClick={() => handleSort('szakfelelos_neve')}>
                                    <div className="th-content">Szakfelelős neve {renderSortIcon('szakfelelos_neve')}</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedSzakfelelosok.map(szak => (
                                <tr key={szak.szak_kod}>
                                    <td>{szak.kepzes_neve}</td>
                                    <td>{szak.kepzesi_szint}</td>
                                    <td>{szak.szakfelelos_neve}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {sortedSzakfelelosok.length === 0 && (
                        <p className="missing-reports-message">Nincs a feltételeknek megfelelő szak.</p>
                    )}
                </div>
            )}
        </>
    );
}

export default MissingReportsTable;
